import { Meta } from "@/shared/components";
import { Streams } from "@/admin/features/streams";

/**
 * Страница реестра эфиров
 */
export function StreamsPage() {
  return (
    <>
      <Meta title="Эфиры" />
      <Streams />
    </>
  );
}
